document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('cart:updated', function (evt) {
    console.log('cart updated');
    getCart();
  });

  // create mutation observer to watch for changes to the cart
  const targetNode = document.getElementById('cart-icon-bubble');
  const config = { attributes: true, childList: true, subtree: true };
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      getCart();
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});

async function getCart() {
  try {
    const response = await fetch('/cart.js');

    if (response.ok) {
      const data = await response.json();
      const items = data.items;
      const itemCount = data.item_count;
      const giftWithProductId = window.giftWithProduct;
      let totalPrice = data.total_price;
      console.log(items);

      if (itemCount > 0) {
        if (giftWithProductId !== null && giftWithProductId !== undefined && giftWithProductId !== '') {
          const giftIsInCart = items.some((item) => item.variant_id == giftWithProductId);
          const giftPrice = window.giftwithProductPrice;

          // if gift is not in cart, add it
          let giftProductObject = {
            items: [
              {
                id: giftWithProductId,
                quantity: 1,
                properties: {
                  free_gift: 'true',
                },
              },
            ],
          };

          // find the line item key of the gift (Used to remove the gift from the cart if needed)
          let giftItemKey;
          if (giftIsInCart == true) {
            let giftItem = items.find((item) => item.properties.free_gift == 'true');
            giftItemKey = giftItem.key;
          }

          // if using product based logic to add gift
          if (window.giftLogicCartProducts !== null && window.giftLogicCartProducts !== undefined && window.giftLogicCartProducts !== '') {
            let logicProducts = window.giftLogicCartProducts;

            // checking if any of the logic products variants are in the cart
            const logicProductIsInCart = logicProducts.some((logicProduct) => items.some((item) => item.variant_id === logicProduct.variantId));

            console.log(giftIsInCart);
            // if any of the logic products are in the cart, add the gift
            if (logicProductIsInCart == true && giftIsInCart == false) {
              addGiftToCart(giftProductObject);
            } else if (logicProductIsInCart == false && giftIsInCart == true) {
              removeObject = {
                id: giftItemKey,
                quantity: 0,
              };
              giftIsInCart == true ? removeGiftFromCart(removeObject) : null;
            }
          }

          // if using cart total value to add gift
          if (window.giftLogicCartTotal !== null && window.giftLogicCartTotal !== undefined && window.giftLogicCartTotal !== '') {
            let logicCartTotal = window.giftLogicCartTotal;
            logicCartTotal = logicCartTotal;

            if (giftIsInCart == true) {
              totalPrice = totalPrice - giftPrice;
            }

            console.log(logicCartTotal, totalPrice);
            if (totalPrice >= logicCartTotal && giftIsInCart == false) {
              addGiftToCart(giftProductObject);
            } else if (totalPrice < logicCartTotal && giftIsInCart == true) {
              removeObject = {
                id: giftItemKey,
                quantity: 0,
              };
              giftIsInCart == true ? removeGiftFromCart(removeObject) : null;
            }
          }
        }
      }

      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
    }
  } catch (error) {
    console.log(error);
  }
}

async function addGiftToCart(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const data = await response.json();
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.log(error);
  }
}

async function removeGiftFromCart(formData) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const data = await response.json();
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.log(error);
  }
}

const variantButtons = document.querySelectorAll('.swatch:not(.disabled) input');

variantButtons.forEach((buttons) => {
  buttons.addEventListener('click', (e) => {
    id = buttons.getAttribute('data-variant-id');
    e.preventDefault();

    let formData = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
      sections: 'mini-cart,cart-icon-bubble',
    };
    edAddToCart(formData);
  });
});

async function edAddToCart(formData) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const data = await response.json();
      console.log(data);
      let sectionData = data.sections;
      let cartDrawerData = sectionData['mini-cart'];
      let cartBubbleData = sectionData['cart-icon-bubble'];

      const editionCart = document.getElementById('mini-cart');
      editionCart.innerHTML = cartDrawerData;
      const editionCartBubble = document.getElementById('cart-icon-bubble');
      editionCartBubble.innerHTML = cartBubbleData;

      editionCartBubble.click();
    }
  } catch (error) {
    console.log(error);
  }
}